import { Icon } from '@scale/scaleui';
export const BillingApprovalWarningBanner = () => {
  return (
    <div className="w-full rounded-lg border-transparent bg-warning-100 p-2 flex flex-inline mt-4">
      <Icon icon={['far', 'triangle-exclamation']} variant="warning" size="sm" />
      <span className="pt-1">
        Note: Delivery sender will be blocked until the billing setup is approved by the project's
        EM or Revops.
      </span>
    </div>
  );
};
